module.exports = __webpack_public_path__ + "img/logo.a8f1bce3.png";